import { render, staticRenderFns } from "./130.vue?vue&type=template&id=fb087b00&scoped=true&"
import script from "./130.vue?vue&type=script&lang=js&"
export * from "./130.vue?vue&type=script&lang=js&"
import style0 from "./130.vue?vue&type=style&index=0&id=fb087b00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb087b00",
  null
  
)

export default component.exports